import apiClient from './config';

const PUBLISHER_BASE = '/publisher';

// ============================================
// PUBLISHER API ENDPOINTS
// ============================================

// Grades
export const publisherGradeAPI = {
  createGrade: (data) => apiClient.post(`${PUBLISHER_BASE}/grades`, data),
  getGrades: (params) => apiClient.get(`${PUBLISHER_BASE}/grades`, { params }),
  getGrade: (gradeId) => apiClient.get(`${PUBLISHER_BASE}/grades/${gradeId}`),
  updateGrade: (gradeId, data) => apiClient.put(`${PUBLISHER_BASE}/grades/${gradeId}`, data),
  deleteGrade: (gradeId) => apiClient.delete(`${PUBLISHER_BASE}/grades/${gradeId}`),
};

// Subjects
export const publisherSubjectAPI = {
  createSubject: (data) => apiClient.post(`${PUBLISHER_BASE}/subjects`, data),
  getSubjects: (params) => apiClient.get(`${PUBLISHER_BASE}/subjects`, { params }),
  getSubject: (subjectId) => apiClient.get(`${PUBLISHER_BASE}/subjects/${subjectId}`),
  updateSubject: (subjectId, data) => apiClient.put(`${PUBLISHER_BASE}/subjects/${subjectId}`, data),
  deleteSubject: (subjectId) => apiClient.delete(`${PUBLISHER_BASE}/subjects/${subjectId}`),
};

// Publications
export const publisherPublicationAPI = {
  createPublication: (formData) => apiClient.post(`${PUBLISHER_BASE}/publications`, formData),
  getPublications: (params) => apiClient.get(`${PUBLISHER_BASE}/publications`, { params }),
  getPublication: (publicationId) => apiClient.get(`${PUBLISHER_BASE}/publications/${publicationId}`),
  updatePublication: (publicationId, data) => apiClient.put(`${PUBLISHER_BASE}/publications/${publicationId}`, data),
  deletePublication: (publicationId) => apiClient.delete(`${PUBLISHER_BASE}/publications/${publicationId}`),
};

